import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

if (!apiKey) {
  throw new Error('VITE_GOOGLE_MAPS_API_KEY est manquante');
}

setOptions({
  key: apiKey,
  v: 'weekly',
});

export async function loadGooglePlaces() {
  return importLibrary('places');
}